import { useTranslation } from "next-i18next";
import { colors } from "../../../styles/colors";
import { Box } from "../../../styles/basicStyles";
import { FC } from "react";
import Typography from "../../../components/typography";
import Dot from "../../../components/views/dot";

const HowWeCanHelp: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgColor={colors.white}
      pt={{ md: 6.063, xxs: 3.125 }}
      pb={4.25}
    >
      <Box fDirection="column">
        <Typography
          as='h2'
          fSize={{ md: 2.5, xxs: 1.688 }}
          lHeight={{ md: 3, xxs: 2 }}
          fWeight={700}
          style={{ color: colors.black }}
        >
          {t("HOW_WE_CAN_HELP")}
          <Dot
            w={{ md: 0.875, xxs: 0.5 }}
            h={{ md: 0.875, xxs: 0.5 }}
            ml={0.375}
          />
        </Typography>
        <Typography
          fSize={{ md: 1.063, xxs: 1.063 }}
          lHeight={{ md: 1.75, xxs: 1.875 }}
          fWeight={400}
          style={{ color: colors.black }}
          mt={{ md: 1.375, xxs: 1.063 }}
          maxW={{ md: 43.563, xxs: "100%" }}
        >
          {t("HOW_WE_CAN_HELP_PROCES_DESCRIPTION")}
        </Typography>
      </Box>
    </Box>
  );
};

export default HowWeCanHelp;
